import { getCampaignShowsFrequencyEditorId } from '../service/CampaignsEditHelpers/CampaignsEditHelpers';
import { EditCampaignData, EditCampaignValueField } from '../typings/campaignsEdit';
import { ShowsFrequencyInitData } from '../typings/showsFrequency';

export function mapCampaignsDataForEditToInitShowsFrequencyData(
    campaigns: Record<string, EditCampaignData>
): ShowsFrequencyInitData[] {
    return Object.keys(campaigns).reduce((acc: ShowsFrequencyInitData[], campaignId: string) => {
        const value = campaigns[campaignId].value[EditCampaignValueField.showsFrequency];

        acc.push({
            editorId: getCampaignShowsFrequencyEditorId(campaignId),
            isActive: value.isActive,
            showsLimit: value.showsLimit,
            customPeriod: value.customPeriod,
            periodPreset: value.periodPreset
        });

        return acc;
    }, []);
}
